import { useQuery } from "react-query";
import { getPackageLevels } from "../../shipment-editor/upcs/lib/upcData";

export const usePackageLevels = () => {
    return useQuery({
        queryKey: ["packageLevels"],
        initialData: [],
        queryFn: () => getPackageLevels(),
    });
};
